export default {
  unreadNotifications(state) {
    return state.unreadNotifications
  },
  readNotifications(state) {
    return state.readNotifications
  },
  allNotifications(state) {
    return state.allNotifications
  },
  idUnfixNews(state) {
    return state.idUnfixNews
  },
  idFixNews(state) {
    return state.idFixNews
  },
}
